import { useLocation } from 'react-router-dom';
import { type PageContext } from '../model/chatTypes';

export function useChatContext(): PageContext {
  const location = useLocation();
  const path = location.pathname;

  if (path.includes('/auth/login')) return 'login';
  if (path.includes('/auth/register')) return 'register';
  if (path.includes('/cabinet') || path.includes('/osi') || path.includes('/appartment')) return 'cabinet';
  return 'public';
}
